import { render, staticRenderFns } from "./StartEventDetail.vue?vue&type=template&id=7be32dc9&"
import script from "./StartEventDetail.vue?vue&type=script&lang=js&"
export * from "./StartEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7be32dc9')) {
      api.createRecord('7be32dc9', component.options)
    } else {
      api.reload('7be32dc9', component.options)
    }
    module.hot.accept("./StartEventDetail.vue?vue&type=template&id=7be32dc9&", function () {
      api.rerender('7be32dc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/StartEventDetail.vue"
export default component.exports